import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import '../styles/Pagos.css';
import EliminarPago from './pagos/EliminarPago';
import Excusas from './pagos/Excusas';
import Pago from './pagos/Pago';
import PagoExtraordinario from './pagos/PagoExtraordinario';
import PagoFacil from './pagos/PagoFacil';
import PlanPagos from './pagos/PlanPagos';
import Recibo from './pagos/Recibo';
import ReportePagosPorCajero from './pagos/ReportePagosPorCajero';

const Pagos = () => {
  const location = useLocation();
  const [opcionActiva, setOpcionActiva] = useState('pago');
  const [prestamoIdInicial, setPrestamoIdInicial] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const opcion = params.get('opcion') || 'pago';
    const prestamoId = params.get('prestamoId') || '';

    setOpcionActiva(opcion);
    setPrestamoIdInicial(prestamoId);
  }, [location.search]);

  const renderContenido = () => {
    switch (opcionActiva) {
      case 'pago':
        return <Pago />;
      case 'pago-facil':
        return <PagoFacil />;
      case 'pago-extraordinario':
        return <PagoExtraordinario />;
      case 'recibo':
        return <Recibo />;
      case 'eliminar':
        return <EliminarPago />;
      case 'plan':
        return <PlanPagos prestamoIdInicial={prestamoIdInicial} />;
      case 'excusas':
        return <Excusas />;
      case 'reporte-cajero':
        return <ReportePagosPorCajero />;
      default:
        return <Pago />;
    }
  };

  return (
    <div className="pagos-module">
      <div className="pagos-menu">
        <h2>Módulo de Pagos</h2>
        <nav className="menu-opciones">
          <button
            className={opcionActiva === 'pago' ? 'active' : ''}
            onClick={() => setOpcionActiva('pago')}
          >
            Pago
          </button>
          <button
            className={opcionActiva === 'pago-facil' ? 'active' : ''}
            onClick={() => setOpcionActiva('pago-facil')}
          >
            Pago Fácil
          </button>
          <button
            className={opcionActiva === 'pago-extraordinario' ? 'active' : ''}
            onClick={() => setOpcionActiva('pago-extraordinario')}
          >
            Pago Extraordinario
          </button>
          <button
            className={opcionActiva === 'recibo' ? 'active' : ''}
            onClick={() => setOpcionActiva('recibo')}
          >
            Recibo
          </button>
          <button
            className={opcionActiva === 'eliminar' ? 'active' : ''}
            onClick={() => setOpcionActiva('eliminar')}
          >
            Eliminar Pago
          </button>
          <button
            className={opcionActiva === 'plan' ? 'active' : ''}
            onClick={() => setOpcionActiva('plan')}
          >
            Reporte de Pago x Cliente
          </button>
          <button
            className={opcionActiva === 'excusas' ? 'active' : ''}
            onClick={() => setOpcionActiva('excusas')}
          >
            Excusas
          </button>
          <button
            className={opcionActiva === 'reporte-cajero' ? 'active' : ''}
            onClick={() => setOpcionActiva('reporte-cajero')}
          >
            Reporte de Pagos por Cajero
          </button>
        </nav>
      </div>

      <div className="pagos-contenido">
        {renderContenido()}
      </div>
    </div>
  );
};

export default Pagos;